import { createStyles, Theme, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        contrastText: {
            color: theme.palette.getContrastText(theme.palette.primary.main),
        },
    });

export type TThemableProps = WithStyles<typeof styles>;

export const Themable = withStyles(styles, { withTheme: true });
